module.exports = __webpack_public_path__ + "img/jaiak-main-bg.cf86a58c.jpg";